// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type { CubeMeasureEntry, CubeDimensionEntry } from 'shared/src/api/cube-api-types';

export const mediaBuysCubeMeta = {
  name: 'media_buys',
  title: 'Media Buys',
  measures: {
    'media_buys.count': {
      type: 'number',
      aggType: 'count',
      title: 'Media Buy Count',
      description: 'Number of media buys',
      meta: {
        category: 'utility',
        supports_rollup: true,
        short_description: 'Number of media buys',
        source_tables: ['media_tool.media_buys'],
        formula: 'COUNT(*)',
        inputs: []
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'media_buys.id': {
      sql: 'id',
      type: 'string',
      title: 'Media Buy ID',
      primaryKey: true,
      meta: {
        short_description: 'Media buy identifier',
        source_tables: ['media_tool.media_buys']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buys.name': {
      sql: 'name',
      type: 'string',
      title: 'Media Buy Name',
      meta: {
        short_description: 'Media buy name',
        source_tables: ['media_tool.media_buys']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buys.platform_name': {
      sql: 'platform_name',
      type: 'string',
      title: 'Platform Name',
      meta: {
        short_description: 'Name of the media platform (e.g. Google Ads, Meta)',
        source_tables: ['media_tool.media_platforms']
      }
    } as const satisfies CubeDimensionEntry,
    'media_buys.campaign_numbers': {
      sql: 'to_json(media_buys.campaign_numbers)::text',
      type: 'string',
      title: 'Campaign Numbers',
      meta: {
        short_description: 'JSON array of platform campaign numbers (CN-XXXX format)',
        source_tables: ['media_tool.media_buys']
      }
    } as const satisfies CubeDimensionEntry
  }
};
